import { render } from "./TrialBalance.vue?vue&type=template&id=2f1e3b18&scoped=true"
import script from "./TrialBalance.vue?vue&type=script&lang=js"
export * from "./TrialBalance.vue?vue&type=script&lang=js"

import "./TrialBalance.vue?vue&type=style&index=0&id=2f1e3b18&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f1e3b18"]])

export default __exports__